'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var hasher = require('./hasher.js');

var sha = function sha(name) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = Uint8Array;
                _context.next = 3;
                return crypto.subtle.digest(name, data);

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", new _context.t0(_context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var sha256 = hasher.from({
  name: 'sha2-256',
  code: 18,
  encode: sha('SHA-256')
});
var sha512 = hasher.from({
  name: 'sha2-512',
  code: 19,
  encode: sha('SHA-512')
});
exports.sha256 = sha256;
exports.sha512 = sha512;